import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SubmitEnquiryComponent } from '../snackbars/submit-enquiry/submit-enquiry.component';
import { EnquiryService } from '../services/enquiry.service';
import { DataService } from '../services/data.service';
import { EnquiryStateService } from '../services/enquiry-state.service';
import { Router } from '@angular/router';
import { LocationMappingService } from '../services/location-mapping.service';

@Component({
  selector: 'app-enquiry',
  templateUrl: './enquiry.component.html',
  styleUrls: ['./enquiry.component.css']
})
export class EnquiryComponent implements OnInit {
  public courseList = [];
  public valid = false;
  public emailregex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  // Valid Indian mobile numbers: 10 digits, first digit 6-9 (rejects sequences like 0000000000/1111111111/1234567890 style junk via distinct-digit check below)
  public mobileregex = /^[6-9]\d{9}$/;

  public name = '';
  public email = '';
  public mobile = '';
  public selectedCourse = '';
  public selectedLocation = '';
  public comment = '';
  public page = 'website';
  public branchList: any[] = [];
  public loading = false;
  public hideLocationField = false;
  public hasLocationSlugInUrl = false;

  public branchCoordinates: { [key: string]: { lat: number; lng: number } } = {
    'jayanagar': { lat: 12.926317056929895, lng: 77.58453966731302 },
    'domlur': { lat: 12.960161809173066, lng: 77.63842089614818 },
    'channasandra': { lat: 12.903042546013753, lng: 77.52069885381732 },
    'kormangala': { lat: 12.93719852226826, lng: 77.61944555492933 },
    'yelachenahalli': { lat: 12.89460479478858, lng: 77.56829716731274 },
    'malleshwaram': { lat: 13.006119352167072, lng: 77.57114292498343 },
    'kothanur': { lat: 13.06230934831759, lng: 77.64892494032317 },
    'kammanahalli': { lat: 13.02499111070743, lng: 77.63697779100488 },
    'uttarahalli': { lat: 12.910128628275368, lng: 77.55057635381732 },
    'chandra layout': { lat: 12.958260399689149, lng: 77.52662056731337 },
    's r nagar': { lat: 12.962865551244464, lng: 77.59238880964374 },
    'hanumanthanagar': { lat: 12.9418443950348, lng: 77.55826809614796 }
  };


  constructor(
    private bottomSheetRef: MatBottomSheetRef<EnquiryComponent>,
    private enquiryService: EnquiryService,
    private snackBar: MatSnackBar,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private enquiryStateService: EnquiryStateService,
    private router: Router,
    private locationMappingService: LocationMappingService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) {}

ngOnInit() {
  this.loading = true;

  this.dataService.getCachedCourses().subscribe(data => {
    this.courseList = data.map(c => c.courseName);
    
    // Set default course - prioritize data passed from parent, then first course
    if (this.data && this.data.courseName) {
      this.selectedCourse = this.data.courseName;
    } else if (this.courseList.length > 0) {
      this.selectedCourse = this.courseList[0];
    }
  });

  this.dataService.getCachedBranches().subscribe(data => {
    this.branchList = data;

    // Check if location is passed from URL or parent data
    const locationFromUrl = this.getLocationFromUrl();
    const locationFromData = this.data && this.data.location ? this.data.location : null;
    
    if (locationFromUrl || locationFromData) {
      // Use URL location or data location if provided
      const targetLocation = locationFromUrl || locationFromData;
      
      // Hide location field when location is preset from URL, localStorage, or parent component
      if (locationFromData && !locationFromUrl) {
        this.hideLocationField = true;
      }
      
      const matchingBranch = this.branchList.find(b => 
        b.location.toLowerCase() === targetLocation.toLowerCase()
      );
      
      if (matchingBranch) {
        this.selectedLocation = matchingBranch.location;
        this.snackBar.open(`Location set to: ${this.selectedLocation}`, '', {
          duration: 3000,
          panelClass: ['white-snackbar'],
          horizontalPosition: 'center',
          verticalPosition: 'bottom'
        });
        this.loading = false;
        this.cdr.detectChanges();
      } else {
        // If location not found, fall back to geolocation - show location field
        this.hideLocationField = false;
        this.detectUserLocation(() => {
          this.loading = false;
          this.cdr.detectChanges();
        });
      }
    } else {
      // Detect location only after getting branches - show location field
      this.hideLocationField = false;
      this.detectUserLocation(() => {
        this.loading = false;
        this.cdr.detectChanges();
      });
    }
  });

  // Set source page from passed data
  if (this.data && this.data.source) {
    this.page = this.data.source;
  }
}

  getLocationFromUrl(): string | null {
    // Get current URL and extract location slug
    const url = this.router.url;
    const segments = url.split('/').filter(s => s && !s.includes('?'));
    
    // Check if first segment is a location slug
    if (segments.length > 0) {
      const potentialSlug = segments[0];
      const location = this.locationMappingService.getLocationAndStore(potentialSlug);
      if (location) {
        // Hide location field when coming from URL
        this.hideLocationField = true;
        // Mark that URL has location slug
        this.hasLocationSlugInUrl = true;
        // Set source to dm_ads when location slug is in URL
        this.page = 'dm_ads';
        return location;
      }
    }
    
    // If no location in URL, check localStorage
    const storedLocation = this.locationMappingService.getStoredLocation();
    if (storedLocation) {
      // Hide location field when coming from localStorage
      this.hideLocationField = true;
      return storedLocation;
    }
    
    return null;
  }

  detectUserLocation(callback: () => void) {
  if (!navigator.geolocation) {
    console.warn('Geolocation not supported. Defaulting to Jayanagar.');
    this.selectedLocation = 'Jayanagar';
    this.cdr.detectChanges();
    callback();
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const userLat = position.coords.latitude;
      const userLng = position.coords.longitude;

      // console.log('User Location:', userLat, userLng);

this.branchList = this.branchList
  .map(branch => {
    const normalizedName = branch.location.toLowerCase().replace(/\s+/g, ' ').trim();
    const coord = this.branchCoordinates[normalizedName];

    if (!coord) {
      // console.log(`No coordinates found for branch: '${branch.location}' normalized: '${normalizedName}'`);
      const iframeCoords = this.extractLatLongFromIframe(branch.embeddedLink);
      if (!iframeCoords) return branch; // will be filtered out
      const { lat, lng } = iframeCoords;
      const distance = this.getDistance(userLat, userLng, lat, lng);
      return { ...branch, distance };
    }

    const { lat, lng } = coord;
    const distance = this.getDistance(userLat, userLng, lat, lng);
    return { ...branch, distance };
  })
  .filter(branch => branch.distance !== undefined)
  .sort((a, b) => a.distance - b.distance);


      // console.log('Branches with Distances:', this.branchList);


      // console.log('Sorted Branches by Distance:', this.branchList);

      if (this.branchList.length > 0) {
        this.selectedLocation = this.branchList[0].location;
        this.snackBar.open(`Nearest center selected: ${this.selectedLocation}`, '', {
          duration: 3000,
          panelClass: ['white-snackbar'],
          horizontalPosition: 'center',
          verticalPosition: 'bottom'
        });
      } else {
        this.selectedLocation = 'Jayanagar';
      }

      this.cdr.detectChanges();
      callback();
    },
    () => {
      console.warn('Geolocation failed. Defaulting to Jayanagar.');
      this.selectedLocation = 'Jayanagar';
      this.cdr.detectChanges();
      callback();
    }
  );
}


  extractLatLongFromIframe(iframe: string): { lat: number; lng: number } | null {
    try {
      const srcMatch = iframe.match(/src="([^"]+)"/);
      if (!srcMatch) {
        console.warn('No src attribute found in iframe:', iframe);
        return null;
      }

      const src = srcMatch[1];

      // Try to extract lat and lng with flexible pattern:
      // Google Maps URLs sometimes have !3d<lat>!4d<lng> or !2d<lng>!3d<lat>
      // So check both !3d and !4d, else fallback to !2d and !3d order

      // Attempt pattern !3dLAT!4dLNG
      let latMatch = src.match(/!3d([-+]?[0-9]*\.?[0-9]+)/);
      let lngMatch = src.match(/!4d([-+]?[0-9]*\.?[0-9]+)/);

      if (latMatch && lngMatch) {
        const lat = parseFloat(latMatch[1]);
        const lng = parseFloat(lngMatch[1]);
        // console.log(`Extracted coordinates (3d/4d): lat=${lat}, lng=${lng}`);
        return { lat, lng };
      }

      // If above pattern doesn't match, try !2dLNG!3dLAT
      lngMatch = src.match(/!2d([-+]?[0-9]*\.?[0-9]+)/);
      latMatch = src.match(/!3d([-+]?[0-9]*\.?[0-9]+)/);

      if (latMatch && lngMatch) {
        const lat = parseFloat(latMatch[1]);
        const lng = parseFloat(lngMatch[1]);
        // console.log(`Extracted coordinates (2d/3d): lat=${lat}, lng=${lng}`);
        return { lat, lng };
      }

      console.warn('No coordinate pattern matched in src:', src);
    } catch (err) {
      console.error('Error parsing coordinates from iframe:', err);
    }

    return null;
  }

  getDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Radius of Earth in km
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a = Math.sin(dLat / 2) ** 2 +
              Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
              Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${day}/${month}/${date.getFullYear()}`;
  }

  getBranchLabel(branch: any): string {
    const isNearest = branch.location === this.selectedLocation;
    const distanceText = branch.distance ? `${branch.distance.toFixed(1)} km` : '';
    return `${branch.location}${distanceText ? ' (' + distanceText + (isNearest ? ' - Nearest' : '') + ')' : ''}`;
  }

  checkvalid() {
    this.valid =
      this.name.length >= 3 &&
      this.emailregex.test(this.email.toLowerCase()) &&
      this.isMobileValid(this.mobile);
  }

  isMobileValid(mobile: string): boolean {
    if (!this.mobileregex.test(mobile)) {
      return false;
    }
    // Reject obviously fake numbers made of a single repeated digit (e.g. 9999999999)
    return !/^(\d)\1{9}$/.test(mobile);
  }

  submitEnquiry() {
    if (!this.valid) return;

    // Validate that location and course are set before submission
    if (!this.selectedLocation || !this.selectedCourse) {
      this.snackBar.open('Please select a location and course', '', {
        duration: 3000,
        panelClass: ['white-snackbar'],
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
      return;
    }

    const date = this.formatDate(new Date());
    this.bottomSheetRef.dismiss();

    const enquiryData = {
      name: this.name,
      email: this.email,
      mobile: this.mobile,
      course: this.selectedCourse,
      location: this.selectedLocation,
      comment: this.comment,
      enquiryDate: date,
      source: this.page
    };

    this.enquiryService.postEnquiry(enquiryData).subscribe(res => {
      if (res.status == '200') {
        const d = new Date();
        d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
        document.cookie = "Username=UserLoggedIn; expires=" + d.toUTCString() + "; path=/";

        // Always push to both dataLayer and dataLayer2
        const eventName = this.hasLocationSlugInUrl ? 'ads_enquiry_submission' : 'enquiry_submission';
        if (typeof window !== 'undefined') {
          if ((window as any).dataLayer) {
            (window as any).dataLayer.push({
              event: eventName,
              source: this.hasLocationSlugInUrl ? 'dm_ads' : this.page,
              location: this.selectedLocation
            });
          }
          if ((window as any).dataLayer2) {
            (window as any).dataLayer2.push({
              event: eventName,
              source: this.hasLocationSlugInUrl ? 'dm_ads' : this.page,
              location: this.selectedLocation
            });
          }
        }

        // Mark enquiry as submitted in the state service
        this.enquiryStateService.markEnquiryAsSubmitted();

        // Navigate to thank you page
        this.router.navigate(['/thank-you']);
      } else {
        // Show error snackbar if submission fails
        this.snackBar.open('Submission failed. Please try again.', 'Close', {
          duration: 3000,
          panelClass: ['white-snackbar'],
          horizontalPosition: 'center',
          verticalPosition: 'bottom'
        });
      }
    }, error => {
      // Show error snackbar on error
      this.snackBar.open('An error occurred. Please try again.', 'Close', {
        duration: 3000,
        panelClass: ['white-snackbar'],
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
    });
  }

  openSnackBar() {
    this.snackBar.openFromComponent(SubmitEnquiryComponent, {
      duration: 3000,
      panelClass: ['white-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'bottom'
    });
  }

  openLink(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }
}
